import axios from 'axios';
import authStorage from '../utils/authStorage';

// Create axios instance with base configuration
const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api`,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor - Add auth token to requests
api.interceptors.request.use(
    (config) => {
        const token = authStorage.getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - Handle errors globally
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Skip redirect if this was a login attempt or if we're already on the login page
        const isLoginRequest = error.config?.url?.includes('/auth/admin/login');
        const isLoginPage = window.location.pathname === '/login';

        if (error.response?.status === 401 && !isLoginRequest && !isLoginPage) {
            // Token expired or invalid - only redirect for authorized requests
            authStorage.clearAuth();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;
